import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { UserRoutingModule } from './user-routing.module';
import { ProfileComponent } from './profile/profile.component';
import { SharedModule } from '../../shared.module';
import { CommonModule } from '@angular/common';
import { ManagePasswordComponent } from './manage-password/manage-password.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { IMaskModule } from 'angular-imask';
import { ThirdPartyAppComponent } from './third-party/third-party.component';
import { ThirdPartyAppOpenAiComponent } from './third-party/third-party-open-ai/third-party-open-ai.component';
import { ThirdPartyAppClioComponent } from './third-party/third-party-clio/third-party-clio.component';
import { OpenAiSettingDialogComponent } from './third-party/third-party-open-ai/open-ai-setting-dialog/open-ai-setting-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
	declarations: [ProfileComponent, ManagePasswordComponent, ThirdPartyAppComponent, ThirdPartyAppOpenAiComponent, ThirdPartyAppClioComponent, OpenAiSettingDialogComponent],
	imports: [
		ReactiveFormsModule, FormsModule,
		MatInputModule, MatSelectModule, MatFormFieldModule, MatCardModule, MatToolbarModule, MatButtonModule, MatIconModule, MatListModule, MatMenuModule, MatDialogModule, MatProgressSpinnerModule,
		UserRoutingModule,
		SharedModule, CommonModule,
		IMaskModule
	]
})
export class UserModule { }
